import { render } from "./Banner.vue?vue&type=template&id=2fc1af86"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=2fc1af86&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\andremudancasemgeral\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__